// NEVER captures keystrokes or input values — only route hrefs, clicked control labels and console text.
import { registerClickSink } from './user-action-capture'

export interface Breadcrumb {
  t: number
  type: string
  message: string
}

const MAX_BREADCRUMBS = 30
const MAX_MESSAGE_LEN = 500

let ring: Breadcrumb[] = []

/** Record one breadcrumb. `type` is a coarse category ('nav'|'click'|'console'); `message` short detail. */
export function addBreadcrumb(type: string, message: string): void {
  ring.push({ t: Date.now(), type, message: message.slice(0, MAX_MESSAGE_LEN) })
  if (ring.length > MAX_BREADCRUMBS) ring = ring.slice(-MAX_BREADCRUMBS)
}

/** A copy of the current trail (oldest first), for attaching to an error report. */
export function getBreadcrumbs(): Breadcrumb[] {
  return ring.slice()
}

let installed = false

// Navigation breadcrumbs are added separately, from the router (see router.tsx).
export function installBreadcrumbCapture(): void {
  if (installed || typeof window === 'undefined') return
  installed = true

  registerClickSink((label) => addBreadcrumb('click', label))

  for (const level of ['error', 'warn'] as const) {
    const original = console[level].bind(console)
    console[level] = (...args: unknown[]): void => {
      original(...args)
      try {
        const message = args
          .map((a) => (a instanceof Error ? `${a.name}: ${a.message}` : typeof a === 'string' ? a : String(a)))
          .join(' ')
        addBreadcrumb(`console.${level}`, message)
      } catch {
        // swallow
      }
    }
  }
}
